import { NavigateFunction, Location } from 'react-router-dom';
import React from 'react';

export const LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

let navigateRef: NavigateFunction | null = null;

export function setNavigate(navigate: NavigateFunction) {
  navigateRef = navigate;
}

export function push(path: string | { pathname: string; search?: string; hash?: string }) {
  if (!navigateRef) {
    console.warn('Navigation not initialized');
    return { type: LOCATION_CHANGE, payload: { location: { pathname: typeof path === 'string' ? path : path.pathname } } };
  }

  if (typeof path === 'string') {
    navigateRef(path.startsWith('/') ? path : `/${path}`);
  } else {
    const full = `${path.pathname}${path.search ?? ''}${path.hash ?? ''}`;
    navigateRef(full);
  }

  return {
    type: LOCATION_CHANGE,
    payload: {
      location: typeof path === 'string' ? { pathname: path } : path,
    },
  };
}

export function routerMiddleware() {
  return () => (next: (action: unknown) => unknown) => (action: unknown) => next(action);
}

export function routerReducer(state = { location: { pathname: '/' } }, action: { type: string; payload?: { location?: Location } }) {
  if (action.type === LOCATION_CHANGE && action.payload?.location) {
    return { ...state, location: action.payload.location };
  }
  return state;
}

export function ConnectedRouter({ children }: { children: React.ReactNode }) {
  return React.createElement(React.Fragment, null, children);
}

export { push as replace };
